<form [formGroup]="uniteForm" (ngSubmit)="addUnites()">
  <div class="form-container">
    <div class="form-field">
      <label>{{ 'referentiels.list.uniteProperties.codeCourt.header'| transloco }}<span class="required">*</span></label>
      <input pInputText formControlName="codeCourt" class="flex-auto" />
      <small class="p-error block">
        @if (uniteForm.controls.codeCourt.errors?.required) {
          <p-message *ngIf="uniteForm.controls['codeCourt'].invalid && uniteForm.controls['codeCourt'].touched" severity="danger" text="Le champ pour le code court est requis."></p-message>
        } @else if (uniteForm.controls.codeCourt.errors?.maxlength) {
          <p-message *ngIf="uniteForm.controls['codeCourt'].invalid && uniteForm.controls['codeCourt'].touched" severity="danger" text="Le code court ne doit pas dépasser 3 caractères."></p-message>
        }
      </small>
    </div>

    <div class="form-field">
      <label>{{ 'referentiels.list.uniteProperties.codeHecate.header'| transloco }}<span class="required">*</span></label>
      <input pInputText formControlName="codeHecate" class="flex-auto" />
      <small class="p-error block">
        @if (uniteForm.controls.codeHecate.errors?.required) {
          <p-message *ngIf="uniteForm.controls['codeHecate'].invalid && uniteForm.controls['codeHecate'].touched" severity="danger" text="Le champ pour le code hecate est requis."></p-message>
        } @else if (uniteForm.controls.codeHecate.errors?.pattern) {
          <p-message *ngIf="uniteForm.controls['codeHecate'].invalid && uniteForm.controls['codeHecate'].touched" severity="danger" text="Le code hecate doit être un nombre."></p-message>
        } @else if (uniteForm.controls.codeHecate.errors?.maxlength) {
          <p-message *ngIf="uniteForm.controls['codeHecate'].invalid && uniteForm.controls['codeHecate'].touched" severity="danger" text="Le code hecate ne doit pas dépasser 10 caractères."></p-message>
        }
      </small>
    </div>

    <div class="form-field">
      <label>{{ 'referentiels.list.uniteProperties.designation.header'| transloco }}<span class="required">*</span></label>
      <input pInputText formControlName="designation" class="flex-auto" />
      <small class="p-error block">
        @if (uniteForm.controls.designation.errors?.required) {
          <p-message *ngIf="uniteForm.controls['designation'].invalid && uniteForm.controls['designation'].touched" severity="danger" text="Le champ pour la designation est requis."></p-message>
        } @else if (uniteForm.controls.designation.errors?.maxlength) {
          <p-message *ngIf="uniteForm.controls['designation'].invalid && uniteForm.controls['designation'].touched" severity="danger" text="La désignation ne doit pas dépasser 20 caractères."></p-message>
        }
      </small>
    </div>
  </div>

  <div class="button-container">
    <p-button pRipple label="{{ 'button.cancel' | transloco }}" [rounded]="true" severity="secondary" (onClick)="close(false)" />
    <p-button pRipple label="{{ 'button.validate' | transloco }}" [rounded]="true" type="submit" [disabled]="uniteForm.invalid" />
  </div>

  <div *ngIf="submitting" class="loading-spinner">
    <p-progressSpinner [style]="{ width: '3rem', height: '3rem' }"></p-progressSpinner>
  </div>
</form>
<p-toast />
